module.exports = __webpack_public_path__ + "img/58800.e01a3167.jpg";